export default __webpack_public_path__ + "static/darkVectorMobile-6866a54bb4d290320e5d28d8af592e95.webp";